import { Tab, Tabs } from "@monta/design-system";

import type Props from "./types";

const MultiLessonTabs = ({
  activeDetailsTabId = 1,
  onChange
}: Readonly<Props>) => {
  const activeTabStyle = "!bg-[#FF6A00] !text-white border-none !px-10";

  return (
    <Tabs
      className="flex items-center bg-[#F2F4F7] border !border-[#EAECF0] !shadow-none rounded-2 h-10 px-1 gap-1"
      activeTabId={activeDetailsTabId}
      onChange={onChange}
    >
      <Tab
        id={1}
        className="rounded-2 flex items-center justify-center !pb-0 h-[34px] border-none px-6 py-1 text-sm font-medium !text-neutral-400 after:!hidden transition-colors duration-200 whitespace-nowrap cursor-pointer hover:bg-[#FF6A00]/50 hover:!text-white active:scale-[.9] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6A00]/40"
        classes={{
          active: activeTabStyle
        }}
      >
        کتاب
      </Tab>

      <Tab
        id={2}
        className="rounded-2 text-medium flex items-center justify-center !pb-0 h-[34px] border-none px-6 py-1 text-sm font-medium !text-neutral-400 after:!hidden transition-colors duration-200 whitespace-nowrap cursor-pointer hover:bg-[#FF6A00]/50 hover:!text-white active:scale-[.9] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6A00]/40"
        classes={{
          active: activeTabStyle
        }}
      >
        گروه درسی
      </Tab>
    </Tabs>
  );
};

export default MultiLessonTabs;
